import React from 'react';

import { InputText as PrimeReactInputText } from 'primereact/inputtext';

import { handleEnterKey } from 'utils/utils';


const InputText: React.FC<any> = (props): JSX.Element => {
    const { value, id, className, label, ...passThroughProps } = props;

    return (
        <span className={`${className} mb-5`}>
            <div className="p-float-label">
                <PrimeReactInputText
                    id={id}
                    name={id}
                    value={value || ""}
                    className="w-100"
                    onKeyDown={(event) => handleEnterKey(event, id)}
                    {...passThroughProps}
                />
                <label htmlFor={id}>
                    {label}
                </label>
            </div>
        </span>
    );
}

export default InputText;
